var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound62AError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M41.5 43.5A2.5 2.5 0 0 1 44 41h11.5a2.5 2.5 0 0 1 2.5 2.5v10a2.5 2.5 0 0 1-2.5 2.5h-14V43.5ZM24 43.5a2.5 2.5 0 0 1 2.5-2.5H38a2.5 2.5 0 0 1 2.5 2.5V56h-14a2.5 2.5 0 0 1-2.5-2.5v-10Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M24 46v7.5a2.5 2.5 0 0 0 2.5 2.5h29a2.5 2.5 0 0 0 2.5-2.5V46"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M4 43.5A2.5 2.5 0 0 1 6.5 41h11a2.5 2.5 0 0 1 2.5 2.5v10a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 53.5v-10Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M4 46v7.5A2.5 2.5 0 0 0 6.5 56h11a2.5 2.5 0 0 0 2.5-2.5V46"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M20.666 16.1a2.5 2.5 0 0 1-2.5 2.5H6.5A2.5 2.5 0 0 1 4 16.1v-10a2.5 2.5 0 0 1 2.5-2.5h14.166v12.5ZM38.334 16.1a2.5 2.5 0 0 1-2.5 2.5H24.166a2.5 2.5 0 0 1-2.5-2.5V3.6h16.666v12.5ZM56 16.1a2.5 2.5 0 0 1-2.5 2.5H41.833a2.5 2.5 0 0 1-2.5-2.5V3.6H53.5A2.5 2.5 0 0 1 56 6.1v10Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DB5C67",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M56 13.6V6.1a2.5 2.5 0 0 0-2.5-2.5h-47A2.5 2.5 0 0 0 4 6.1v7.5"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  stroke: "#DB5C67",
  strokeWidth: 2,
  d: "M45 31a5 5 0 1 1 10 0 5 5 0 0 1-10 0ZM13 31a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z"
})));
SvgRound62AError.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound62AError);
export default ForwardRef;